/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-11-20 14:48:32.

export interface CreateAddressRequest {
    externalReferenceId: string;
    countryId: string;
    placeId: string;
    placeName: string;
    zipCode: string;
    streetName: string;
    streetNameTransformed: string;
    number: number;
    subNumber: number;
    letter: string;
    floor: number;
    apartmentNo: number;
    regionalCode: string;
    regionalSubCode: string;
    regionalPlusCode: string;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    validFrom: DateAsString;
    validTo: DateAsString;
}

export interface WebBooleanResponse {
    result: boolean; problemResponseData?: ProblemResponseData|null;
}

export interface UpdateAddressRequest {
    id: string;
    externalReferenceId: string;
    countryId: string;
    placeId: string;
    placeName: string;
    zipCode: string;
    streetName: string;
    streetNameTransformed: string;
    number: number;
    subNumber: number;
    letter: string;
    floor: number;
    apartmentNo: number;
    regionalCode: string;
    regionalSubCode: string;
    regionalPlusCode: string;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    validFrom: DateAsString;
    validTo: DateAsString;
}

export interface MultipartFile extends InputStreamSource {
    name: string;
    bytes: any;
    empty: boolean;
    resource: Resource;
    size: number;
    originalFilename: string;
    contentType: string;
}

export interface FindCountryByCriteriaRequest {
    isoAlpha3: string;
    isoAlpha2: string;
    isoNumericCode: string;
    isoName: string;
}

export interface SearchRequest extends Serializable {
    filters: FilterRequest[];
    sorts: SortRequest[];
    page: number;
    size: number;
}

export interface WebStringResponse extends WebResponseEntity<string> {
    result: string; problemResponseData?: ProblemResponseData|null;
}

export interface CreateGDRTypeRequest {
    name: string;
    levelsRequest: CreateGDRLevelsRequest;
    validFrom: DateAsString;
    validTo: DateAsString;
    default: boolean;
}

export interface ExcludeGdrTypeLevelRequest {
    gdrTypeId: string;
    levelId: string;
}

export interface CreateLevelItemsRequest {
    levelId: string;
    levelItems: CreateLevelItemRequest[];
}

export interface CreateLevelRequest {
    code: string;
    subCode: string;
    name: string;
    localName: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    timeZoneId: string;
    geoDataId: string;
}

export interface CreateSubLevelRequest extends CreateLevelRequest {
    levelIndex: number;
}

export interface DeactivateLevelItemRequest {
    levelId: string;
    id: string;
}

export interface UpdateLevelRequest {
    id: string;
    code: string;
    subCode: string;
    name: string;
    localName: string;
    validTo: DateAsString;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    timeZoneId: string;
}

export interface UpdateLevelItemRequest {
    id: string;
    levelId: string;
    code: string;
    subCode: string;
    name: string;
    localName: string;
    transformedName: string;
    validTo: DateAsString;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    timeZoneId: string;
}

export interface CreateLevelNameRequest {
    level: number;
    name: string;
    localName: string;
    validFrom: DateAsString;
    validTo: DateAsString;
}

export interface UpdateLevelNameRequest {
    id: string;
    name: string;
    localName: string;
    validTo: DateAsString;
}

export interface CreatePlaceRequest {
    code: string;
    subCode: string;
    englishName: string;
    localName: string;
    transformedName: string;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    timeZoneId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    geoDataId: string;
}

export interface FindPlaceByRequest {
    code: string;
    subCode: string;
    localName: string;
}

export interface UpdatePlaceRequest {
    id: string;
    code: string;
    subCode: string;
    englishName: string;
    localName: string;
    transformedName: string;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    validTo: DateAsString;
}

export interface CreateStateRequest {
    countryId: string;
    name: string;
    localName: string;
    transformedName: string;
    abbreviation: string;
    zipCodeAbbreviation: string;
    longitude: number;
    latitude: number;
    altitude: number;
    timeZoneId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    geoDataId: string;
}

export interface FindStateByCountryRequest {
    countryId: string;
    excludeInactive: boolean;
}

export interface UpdateStateRequest {
    id: string;
    countryId: string;
    name: string;
    localName: string;
    transformedName: string;
    abbreviation: string;
    zipCodeAbbreviation: string;
    validTo: DateAsString;
}

export interface WebResponseEntity<T> {
    result: T; problemResponseData?: ProblemResponseData|null;
}

export interface AddressCommonDto {
    id: string;
    countryId: string;
    externalReferenceId: string;
    placeId: string;
    placeName: string;
    zipCode: string;
    streetName: string;
    streetNameTransformed: string;
    number: number;
    subNumber: number;
    letter: string;
    floor: number;
    apartmentNo: number;
    regionalCode: string;
    regionalSubCode: string;
    regionalPlusCode: string;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    validFrom: DateAsString;
    validTo: DateAsString;
    activated: boolean;
}

export interface WebResponseObject<T> extends WebResponseBase {
    result: T;
}

export interface WebListResponseEntity<T> {
    result: T[]; problemResponseData?: ProblemResponseData|null;
}

export interface AddressChangeHistoryCommonDto {
    previousAddressId: string;
    newAddressId: string;
    externalReferenceId: string;
    lastUpdatedOn: DateAsString;
    lastUpdateBy: string;
}

export interface Page<T> extends Slice<T> {
    totalPages: number;
    totalElements: number;
}

export interface Resource extends InputStreamSource {
    open: boolean;
    file: any;
    readable: boolean;
    url: URL;
    description: string;
    uri: URI;
    filename: string;
}

export interface InputStreamSource {
    inputStream: any;
}

export interface CountryCommonDto {
    id: string;
    ppCountryId: string;
    isoAlpha3: string;
    isoAlpha2: string;
    isoName: string;
    isoNumericCode: string;
    localName: string;
    transformedName: string;
    countryFlag: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    timeZoneId: string;
    geoDataId: string;
    platformServiceCode: string;
    domicile: boolean;
    activated: boolean;
    onPPCountryList: boolean;
}

export interface CountryChangesCommonDto {
    ppCountryId: string;
    maCountryId: string;
    changes: CountryDifferenceDto[];
    new: boolean;
}

export interface PPCountryCommonDtoList {
    platformProviderCountryCommonDtoList: PlatformProviderCountryCommonDto[];
    downloadedByUserId: string;
}

export interface FilterRequest extends Serializable {
    key: string;
    operator: Operator;
    field_type: FieldType;
    value: any;
    value_to: any;
    values: any[];
}

export interface SortRequest extends Serializable {
    key: string;
    direction: SortDirection;
}

export interface Serializable {
}

export interface CreateGDRLevelsRequest {
    rootLevel: GDRTypeLevelRequest;
    subLevels: GDRTypeLevelRequest[];
    leafLevel: GDRTypeLevelRequest;
    relationValidFrom: DateAsString;
    relationValidTo: DateAsString;
}

export interface GDRTypeCommonDto {
    id: string;
    name: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    levels: LevelCommonDto[];
    default: boolean;
    activated: boolean;
}

export interface GdrTypeTreeCommonDto {
    id: string;
    gdrName: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    tree: GdrTypeLevelTreeDto[];
    default: boolean;
    activated: boolean;
}

export interface CreateLevelItemRequest {
    code: string;
    subCode: string;
    name: string;
    localName: string;
    transformedName: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    timeZoneId: string;
    geoDataId: string;
}

export interface LevelCommonDto {
    id: string;
    levelName: string;
    name: string;
    code: string;
    subCode: string;
    localName: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    levelItems: LevelItemCommonDto[];
    activated: boolean;
}

export interface LevelNameCommonDto {
    id: string;
    level: number;
    name: string;
    localName: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    activated: boolean;
}

export interface PlaceCommonDto {
    geoDataID: string;
    code: string;
    subCode: string;
    englishName: string;
    localName: string;
    transformedName: string;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    timeZoneId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    activated: boolean;
}

export interface StateCommonDto {
    id: string;
    countryId: string;
    name: string;
    localName: string;
    transformedName: string;
    abbreviation: string;
    zipCodeAbbreviation: string;
    latitude: number;
    longitude: number;
    altitude: number;
    timeZoneId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    activated: boolean;
}

export interface ProblemResponseData extends Serializable {
    error: boolean;
    problems: ProblemBase[];
}

export interface WebResponseBase extends Serializable {
    problemResponseData: ProblemResponseData;
}

export interface Sort extends Streamable<Order>, Serializable {
    sorted: boolean;
    unsorted: boolean;
}

export interface Pageable {
    offset: number;
    sort: Sort;
    paged: boolean;
    unpaged: boolean;
    pageNumber: number;
    pageSize: number;
}

export interface URL extends Serializable {
}

export interface URI extends Comparable<URI>, Serializable {
}

export interface CountryDifferenceDto {
    name: string;
    value: any;
}

export interface PlatformProviderCountryCommonDto {
    id: string;
    alpha3: string;
    alpha2: string;
    name: string;
    numericCode: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    active: boolean;
}

export interface GDRTypeLevelRequest {
    level: string;
    levelItems: GDRLevelItemRequest[];
}

export interface GdrTypeLevelTreeDto {
    levelId: string;
    levelName: string;
    parentLevelId: string;
    parentLevelName: string;
    levelItems: GdrTypeLevelItemTreeDto[];
}

export interface LevelItemCommonDto {
    id: string;
    levelId: string;
    code: string;
    subCode: string;
    localName: string;
    transformedName: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    activated: boolean;
}

export interface ResponseEntity<T> {
    result: T;
    problemResponseData?: ProblemResponseData|null;
}

export interface ProblemBase extends Serializable {
    problemCode: number;
    applicationOrigin: string;
    exceptionCode: string;
    message: string;
    details: string;
    type: string;
}

export interface Slice<T> extends Streamable<T> {
    size: number;
    content: T[];
    number: number;
    sort: Sort;
    first: boolean;
    numberOfElements: number;
    pageable: Pageable;
    last: boolean;
}

export interface GDRLevelItemRequest {
    levelItem: string;
    children: string[];
}

export interface GdrTypeLevelItemTreeDto {
    levelItemId: string;
    levelItemName: string;
    children: GdrTypeLevelItemChildDto[];
}

export interface Streamable<T> extends Iterable<T>, Supplier<Stream<T>> {
    empty: boolean;
}

export interface Order extends Serializable {
    direction: Direction;
    property: string;
    ignoreCase: boolean;
    nullHandling: NullHandling;
    ascending: boolean;
    descending: boolean;
}

export interface Comparable<T> {
}

export interface GdrTypeLevelItemChildDto {
    childLevelId: string;
    childLevelName: string;
}

export interface HttpEntity<T> {
    headers: { [index: string]: string[] };
    body: T;
}

export interface Iterable<T> {
}

export interface Supplier<T> {
}

export interface Stream<T> extends BaseStream<T, Stream<T>> {
}

export interface BaseStream<T, S> extends AutoCloseable {
    parallel: boolean;
}

export interface AutoCloseable {
}

export interface HttpClient<O> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: O; }): RestResponse<R>;
}

export class RestApplicationClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /geo-data/address/create
     * Java method: com.europoint.geodata.web.controllers.AddressController.create
     */
    create$POST$geo_data_address_create(request: CreateAddressRequest, options?: O): RestResponse<WebResponseEntity<AddressCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/address/create`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/address/delete
     * Java method: com.europoint.geodata.web.controllers.AddressController.deleteAddressById
     */
    deleteAddressById(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/address/delete`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/address/get-all
     * Java method: com.europoint.geodata.web.controllers.AddressController.getAll
     */
    getAll$GET$geo_data_address_getall(options?: O): RestResponse<WebListResponseEntity<AddressCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/address/get-all`, options: options });
    }

    /**
     * HTTP GET /geo-data/address/get-all-active
     * Java method: com.europoint.geodata.web.controllers.AddressController.getAllActive
     */
    getAllActive(options?: O): RestResponse<WebListResponseEntity<AddressCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/address/get-all-active`, options: options });
    }

    /**
     * HTTP GET /geo-data/address/get-by-id
     * Java method: com.europoint.geodata.web.controllers.AddressController.getById
     */
    getById$GET$geo_data_address_getbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<AddressCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/address/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/address/get-by-reference-id
     * Java method: com.europoint.geodata.web.controllers.AddressController.getByReferenceId
     */
    getByReferenceId(queryParams: { referenceId: string; }, options?: O): RestResponse<WebListResponseEntity<AddressCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/address/get-by-reference-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/address/get-by-street
     * Java method: com.europoint.geodata.web.controllers.AddressController.getByStreet
     */
    getByStreet(queryParams: { transformedStreetName: string; }, options?: O): RestResponse<WebListResponseEntity<AddressCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/address/get-by-street`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/address/history/get-all
     * Java method: com.europoint.geodata.web.controllers.AddressController.getAllHistory
     */
    getAllHistory(options?: O): RestResponse<WebListResponseEntity<AddressChangeHistoryCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/address/history/get-all`, options: options });
    }

    /**
     * HTTP GET /geo-data/address/history/get-by-external-reference-id
     * Java method: com.europoint.geodata.web.controllers.AddressController.getByHistoryExternalReferenceId
     */
    getByHistoryExternalReferenceId(options?: O): RestResponse<WebListResponseEntity<AddressChangeHistoryCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/address/history/get-by-external-reference-id`, options: options });
    }

    /**
     * HTTP GET /geo-data/address/search-all
     * Java method: com.europoint.geodata.web.controllers.AddressController.searchAll
     */
    searchAll$GET$geo_data_address_searchall(options?: O): RestResponse<WebResponseEntity<Page<AddressCommonDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/address/search-all`, options: options });
    }

    /**
     * HTTP POST /geo-data/address/update
     * Java method: com.europoint.geodata.web.controllers.AddressController.update
     */
    update$POST$geo_data_address_update(request: UpdateAddressRequest, options?: O): RestResponse<WebResponseEntity<AddressCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/address/update`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/country/create
     * Java method: com.europoint.geodata.web.controllers.CountryController.create
     */
    create$POST$geo_data_country_create(queryParams?: { countryFlag?: MultipartFile; domicile?: boolean; geoAltitude?: number; geoDataId?: string; geoLatitude?: number; geoLongitude?: number; isoAlpha2?: string; isoAlpha3?: string; isoName?: string; isoNumericCode?: string; localName?: string; platformServiceCode?: string; ppCountryId?: string; timeZoneId?: string; transformedName?: string; validFrom?: DateAsString; validTo?: DateAsString; }, options?: O): RestResponse<WebResponseEntity<CountryCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/country/create`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /geo-data/country/deactivate
     * Java method: com.europoint.geodata.web.controllers.CountryController.deactivate
     */
    deactivate$POST$geo_data_country_deactivate(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<CountryCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/country/deactivate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/country/get-all
     * Java method: com.europoint.geodata.web.controllers.CountryController.getAll
     */
    getAll$GET$geo_data_country_getall(queryParams: { excludeInactive: boolean; }, options?: O): RestResponse<WebListResponseEntity<CountryCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/country/get-all`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/country/get-by
     * Java method: com.europoint.geodata.web.controllers.CountryController.getBy
     */
    getBy$GET$geo_data_country_getby(request: FindCountryByCriteriaRequest, options?: O): RestResponse<WebListResponseEntity<CountryCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/country/get-by`, data: request, options: options });
    }

    /**
     * HTTP GET /geo-data/country/get-by-id
     * Java method: com.europoint.geodata.web.controllers.CountryController.getById
     */
    getById$GET$geo_data_country_getbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<CountryCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/country/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/country/get-latest-changes
     * Java method: com.europoint.geodata.web.controllers.CountryController.getLatestChanges
     */
    getLatestChanges(options?: O): RestResponse<WebListResponseEntity<CountryChangesCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/country/get-latest-changes`, options: options });
    }

    /**
     * HTTP GET /geo-data/country/get-latest-platform-provider-country-list
     * Java method: com.europoint.geodata.web.controllers.CountryController.getLatestPlatformProviderCountryList
     */
    getLatestPlatformProviderCountryList(options?: O): RestResponse<WebResponseEntity<PPCountryCommonDtoList>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/country/get-latest-platform-provider-country-list`, options: options });
    }

    /**
     * HTTP GET /geo-data/country/search-all
     * Java method: com.europoint.geodata.web.controllers.CountryController.searchAll
     */
    searchAll$GET$geo_data_country_searchall(request: SearchRequest, options?: O): RestResponse<WebResponseEntity<Page<CountryCommonDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/country/search-all`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/country/update
     * Java method: com.europoint.geodata.web.controllers.CountryController.update
     */
    update$POST$geo_data_country_update(queryParams?: { countryFlag?: MultipartFile; domicile?: boolean; geoAltitude?: number; geoLatitude?: number; geoLongitude?: number; id?: string; isoName?: string; localName?: string; ppCountryId?: string; transformedName?: string; validTo?: DateAsString; }, options?: O): RestResponse<WebResponseEntity<CountryCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/country/update`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /geo-data/data-seeder/countries
     * Java method: com.europoint.geodata.web.controllers.DataSeederController.loadAndSaveCountries
     */
    loadAndSaveCountries(queryParams: { country: string; }, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/data-seeder/countries`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /geo-data/data-seeder/hierarchy
     * Java method: com.europoint.geodata.web.controllers.DataSeederController.loadAndSaveHierarchy
     */
    loadAndSaveHierarchy(queryParams: { country: string; }, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/data-seeder/hierarchy`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /geo-data/data-seeder/leaf-levels
     * Java method: com.europoint.geodata.web.controllers.DataSeederController.loadAndSaveLeafLevels
     */
    loadAndSaveLeafLevels(queryParams: { country: string; }, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/data-seeder/leaf-levels`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /geo-data/data-seeder/level-items
     * Java method: com.europoint.geodata.web.controllers.DataSeederController.loadAndSaveLevelItems
     */
    loadAndSaveLevelItems(queryParams: { country: string; }, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/data-seeder/level-items`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /geo-data/data-seeder/places
     * Java method: com.europoint.geodata.web.controllers.DataSeederController.loadAndSavePlaces
     */
    loadAndSavePlaces(queryParams: { country: string; }, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/data-seeder/places`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /geo-data/data-seeder/root-levels
     * Java method: com.europoint.geodata.web.controllers.DataSeederController.loadAndSaveRootLevels
     */
    loadAndSaveRootLevels(queryParams: { country: string; }, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/data-seeder/root-levels`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /geo-data/data-seeder/sub-levels
     * Java method: com.europoint.geodata.web.controllers.DataSeederController.loadAndSaveSubLevels
     */
    loadAndSaveSubLevels(queryParams: { country: string; }, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/data-seeder/sub-levels`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /geo-data/gdr/create
     * Java method: com.europoint.geodata.web.controllers.GDRTypeController.create
     */
    create$POST$geo_data_gdr_create(request: CreateGDRTypeRequest, options?: O): RestResponse<WebResponseEntity<GDRTypeCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/gdr/create`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/gdr/create-tree
     * Java method: com.europoint.geodata.web.controllers.GDRTypeController.createTree
     */
    createTree(request: CreateGDRTypeRequest, options?: O): RestResponse<WebResponseEntity<GdrTypeTreeCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/gdr/create-tree`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/gdr/deactivate
     * Java method: com.europoint.geodata.web.controllers.GDRTypeController.deactivate
     */
    deactivate$POST$geo_data_gdr_deactivate(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<GDRTypeCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/gdr/deactivate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /geo-data/gdr/exclude
     * Java method: com.europoint.geodata.web.controllers.GDRTypeController.exclude
     */
    exclude(request: ExcludeGdrTypeLevelRequest, options?: O): RestResponse<WebResponseEntity<GDRTypeCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/gdr/exclude`, data: request, options: options });
    }

    /**
     * HTTP GET /geo-data/gdr/get-all
     * Java method: com.europoint.geodata.web.controllers.GDRTypeController.getAll
     */
    getAll$GET$geo_data_gdr_getall(options?: O): RestResponse<WebListResponseEntity<GDRTypeCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/gdr/get-all`, options: options });
    }

    /**
     * HTTP GET /geo-data/gdr/get-by-id
     * Java method: com.europoint.geodata.web.controllers.GDRTypeController.getBy
     */
    getBy$GET$geo_data_gdr_getbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<GDRTypeCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/gdr/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/gdr/get-tree
     * Java method: com.europoint.geodata.web.controllers.GDRTypeController.getTree
     */
    getTree(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<GdrTypeTreeCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/gdr/get-tree`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/gdr/search-all
     * Java method: com.europoint.geodata.web.controllers.GDRTypeController.searchAll
     */
    searchAll$GET$geo_data_gdr_searchall(searchRequest: SearchRequest, options?: O): RestResponse<WebResponseEntity<Page<GDRTypeCommonDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/gdr/search-all`, data: searchRequest, options: options });
    }

    /**
     * HTTP POST /geo-data/level/deactivate
     * Java method: com.europoint.geodata.web.controllers.LevelController.deactivate
     */
    deactivate$POST$geo_data_level_deactivate(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<LevelCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/level/deactivate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /geo-data/level/deactivate-level-items
     * Java method: com.europoint.geodata.web.controllers.LevelController.deactivateLevelItem
     */
    deactivateLevelItem(request: DeactivateLevelItemRequest, options?: O): RestResponse<WebResponseEntity<LevelCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/level/deactivate-level-items`, data: request, options: options });
    }

    /**
     * HTTP GET /geo-data/level/get-all
     * Java method: com.europoint.geodata.web.controllers.LevelController.getAll
     */
    getAll$GET$geo_data_level_getall(options?: O): RestResponse<WebListResponseEntity<LevelCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/level/get-all`, options: options });
    }

    /**
     * HTTP GET /geo-data/level/get-by-id
     * Java method: com.europoint.geodata.web.controllers.LevelController.getById
     */
    getById$GET$geo_data_level_getbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<LevelCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/level/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /geo-data/level/leaf/create
     * Java method: com.europoint.geodata.web.controllers.LevelController.createLeafLevel
     */
    createLeafLevel(request: CreateLevelRequest, options?: O): RestResponse<WebResponseEntity<LevelCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/level/leaf/create`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/level/level-items/add
     * Java method: com.europoint.geodata.web.controllers.LevelController.addLevelItems
     */
    addLevelItems(request: CreateLevelItemsRequest, options?: O): RestResponse<WebResponseEntity<LevelCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/level/level-items/add`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/level/root/create
     * Java method: com.europoint.geodata.web.controllers.LevelController.createRootLevel
     */
    createRootLevel(request: CreateLevelRequest, options?: O): RestResponse<WebResponseEntity<LevelCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/level/root/create`, data: request, options: options });
    }

    /**
     * HTTP GET /geo-data/level/search-all
     * Java method: com.europoint.geodata.web.controllers.LevelController.searchAll
     */
    searchAll$GET$geo_data_level_searchall(request: SearchRequest, options?: O): RestResponse<WebResponseEntity<Page<LevelCommonDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/level/search-all`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/level/sublevel/create
     * Java method: com.europoint.geodata.web.controllers.LevelController.createSubLevel
     */
    createSubLevel(request: CreateSubLevelRequest, options?: O): RestResponse<WebResponseEntity<LevelCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/level/sublevel/create`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/level/update
     * Java method: com.europoint.geodata.web.controllers.LevelController.update
     */
    update$POST$geo_data_level_update(request: UpdateLevelRequest, options?: O): RestResponse<WebResponseEntity<LevelCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/level/update`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/level/update-level-items
     * Java method: com.europoint.geodata.web.controllers.LevelController.updateLevelItem
     */
    updateLevelItem(request: UpdateLevelItemRequest, options?: O): RestResponse<WebResponseEntity<LevelCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/level/update-level-items`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/levelname/create
     * Java method: com.europoint.geodata.web.controllers.LevelNameController.create
     */
    create$POST$geo_data_levelname_create(request: CreateLevelNameRequest, options?: O): RestResponse<WebResponseEntity<LevelNameCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/levelname/create`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/levelname/deactivate
     * Java method: com.europoint.geodata.web.controllers.LevelNameController.deactivate
     */
    deactivate$POST$geo_data_levelname_deactivate(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<LevelNameCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/levelname/deactivate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/levelname/get-all
     * Java method: com.europoint.geodata.web.controllers.LevelNameController.getAll
     */
    getAll$GET$geo_data_levelname_getall(options?: O): RestResponse<WebListResponseEntity<LevelNameCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/levelname/get-all`, options: options });
    }

    /**
     * HTTP GET /geo-data/levelname/get-by-id
     * Java method: com.europoint.geodata.web.controllers.LevelNameController.getById
     */
    getById$GET$geo_data_levelname_getbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<LevelNameCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/levelname/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /geo-data/levelname/update
     * Java method: com.europoint.geodata.web.controllers.LevelNameController.update
     */
    update$POST$geo_data_levelname_update(request: UpdateLevelNameRequest, options?: O): RestResponse<WebResponseEntity<LevelNameCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/levelname/update`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/place/create
     * Java method: com.europoint.geodata.web.controllers.PlaceController.create
     */
    create$POST$geo_data_place_create(request: CreatePlaceRequest, options?: O): RestResponse<WebResponseEntity<PlaceCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/place/create`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/place/deactivate
     * Java method: com.europoint.geodata.web.controllers.PlaceController.update
     */
    update$POST$geo_data_place_deactivate(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<PlaceCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/place/deactivate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/place/find-by-country-id
     * Java method: com.europoint.geodata.web.controllers.PlaceController.findByCountryId
     */
    findByCountryId(queryParams: { countryId: string; }, options?: O): RestResponse<WebListResponseEntity<PlaceCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/place/find-by-country-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/place/get-all
     * Java method: com.europoint.geodata.web.controllers.PlaceController.getAll
     */
    getAll$GET$geo_data_place_getall(queryParams: { excludeInactive: boolean; }, options?: O): RestResponse<WebListResponseEntity<PlaceCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/place/get-all`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/place/get-by
     * Java method: com.europoint.geodata.web.controllers.PlaceController.getBy
     */
    getBy$GET$geo_data_place_getby(request: FindPlaceByRequest, options?: O): RestResponse<WebListResponseEntity<PlaceCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/place/get-by`, data: request, options: options });
    }

    /**
     * HTTP GET /geo-data/place/get-by-id
     * Java method: com.europoint.geodata.web.controllers.PlaceController.getById
     */
    getById$GET$geo_data_place_getbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<PlaceCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/place/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/place/search-all
     * Java method: com.europoint.geodata.web.controllers.PlaceController.searchAll
     */
    searchAll$GET$geo_data_place_searchall(searchRequest: SearchRequest, options?: O): RestResponse<WebResponseEntity<Page<PlaceCommonDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/place/search-all`, data: searchRequest, options: options });
    }

    /**
     * HTTP POST /geo-data/place/update
     * Java method: com.europoint.geodata.web.controllers.PlaceController.update
     */
    update$POST$geo_data_place_update(request: UpdatePlaceRequest, options?: O): RestResponse<WebResponseEntity<PlaceCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/place/update`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/state/create
     * Java method: com.europoint.geodata.web.controllers.StateController.create
     */
    create$POST$geo_data_state_create(request: CreateStateRequest, options?: O): RestResponse<WebResponseEntity<StateCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/state/create`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/state/deactivate
     * Java method: com.europoint.geodata.web.controllers.StateController.deactivate
     */
    deactivate$POST$geo_data_state_deactivate(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<StateCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/state/deactivate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/state/get-by-country
     * Java method: com.europoint.geodata.web.controllers.StateController.getByCountry
     */
    getByCountry(request: FindStateByCountryRequest, options?: O): RestResponse<WebListResponseEntity<StateCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/state/get-by-country`, data: request, options: options });
    }

    /**
     * HTTP GET /geo-data/state/get-by-id
     * Java method: com.europoint.geodata.web.controllers.StateController.getById
     */
    getById$GET$geo_data_state_getbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<StateCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/state/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/state/get-by-name
     * Java method: com.europoint.geodata.web.controllers.StateController.getByName
     */
    getByName(queryParams: { transformedName: string; }, options?: O): RestResponse<WebListResponseEntity<StateCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/state/get-by-name`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /geo-data/state/search-all
     * Java method: com.europoint.geodata.web.controllers.StateController.searchAll
     */
    searchAll$GET$geo_data_state_searchall(request: SearchRequest, options?: O): RestResponse<WebResponseEntity<Page<StateCommonDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`geo-data/state/search-all`, data: request, options: options });
    }

    /**
     * HTTP POST /geo-data/state/update
     * Java method: com.europoint.geodata.web.controllers.StateController.update
     */
    update$POST$geo_data_state_update(request: UpdateStateRequest, options?: O): RestResponse<WebResponseEntity<StateCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`geo-data/state/update`, data: request, options: options });
    }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export type DateAsString = string;

/**
 * Values:
 * - `CONTINUE`
 * - `SWITCHING_PROTOCOLS`
 * - `PROCESSING`
 * - `CHECKPOINT`
 * - `OK`
 * - `CREATED`
 * - `ACCEPTED`
 * - `NON_AUTHORITATIVE_INFORMATION`
 * - `NO_CONTENT`
 * - `RESET_CONTENT`
 * - `PARTIAL_CONTENT`
 * - `MULTI_STATUS`
 * - `ALREADY_REPORTED`
 * - `IM_USED`
 * - `MULTIPLE_CHOICES`
 * - `MOVED_PERMANENTLY`
 * - `FOUND`
 * - `MOVED_TEMPORARILY` - @deprecated
 * - `SEE_OTHER`
 * - `NOT_MODIFIED`
 * - `USE_PROXY` - @deprecated
 * - `TEMPORARY_REDIRECT`
 * - `PERMANENT_REDIRECT`
 * - `BAD_REQUEST`
 * - `UNAUTHORIZED`
 * - `PAYMENT_REQUIRED`
 * - `FORBIDDEN`
 * - `NOT_FOUND`
 * - `METHOD_NOT_ALLOWED`
 * - `NOT_ACCEPTABLE`
 * - `PROXY_AUTHENTICATION_REQUIRED`
 * - `REQUEST_TIMEOUT`
 * - `CONFLICT`
 * - `GONE`
 * - `LENGTH_REQUIRED`
 * - `PRECONDITION_FAILED`
 * - `PAYLOAD_TOO_LARGE`
 * - `REQUEST_ENTITY_TOO_LARGE` - @deprecated
 * - `URI_TOO_LONG`
 * - `REQUEST_URI_TOO_LONG` - @deprecated
 * - `UNSUPPORTED_MEDIA_TYPE`
 * - `REQUESTED_RANGE_NOT_SATISFIABLE`
 * - `EXPECTATION_FAILED`
 * - `I_AM_A_TEAPOT`
 * - `INSUFFICIENT_SPACE_ON_RESOURCE` - @deprecated
 * - `METHOD_FAILURE` - @deprecated
 * - `DESTINATION_LOCKED` - @deprecated
 * - `UNPROCESSABLE_ENTITY`
 * - `LOCKED`
 * - `FAILED_DEPENDENCY`
 * - `TOO_EARLY`
 * - `UPGRADE_REQUIRED`
 * - `PRECONDITION_REQUIRED`
 * - `TOO_MANY_REQUESTS`
 * - `REQUEST_HEADER_FIELDS_TOO_LARGE`
 * - `UNAVAILABLE_FOR_LEGAL_REASONS`
 * - `INTERNAL_SERVER_ERROR`
 * - `NOT_IMPLEMENTED`
 * - `BAD_GATEWAY`
 * - `SERVICE_UNAVAILABLE`
 * - `GATEWAY_TIMEOUT`
 * - `HTTP_VERSION_NOT_SUPPORTED`
 * - `VARIANT_ALSO_NEGOTIATES`
 * - `INSUFFICIENT_STORAGE`
 * - `LOOP_DETECTED`
 * - `BANDWIDTH_LIMIT_EXCEEDED`
 * - `NOT_EXTENDED`
 * - `NETWORK_AUTHENTICATION_REQUIRED`
 */
export const enum HttpStatus {
    CONTINUE = "CONTINUE",
    SWITCHING_PROTOCOLS = "SWITCHING_PROTOCOLS",
    PROCESSING = "PROCESSING",
    CHECKPOINT = "CHECKPOINT",
    OK = "OK",
    CREATED = "CREATED",
    ACCEPTED = "ACCEPTED",
    NON_AUTHORITATIVE_INFORMATION = "NON_AUTHORITATIVE_INFORMATION",
    NO_CONTENT = "NO_CONTENT",
    RESET_CONTENT = "RESET_CONTENT",
    PARTIAL_CONTENT = "PARTIAL_CONTENT",
    MULTI_STATUS = "MULTI_STATUS",
    ALREADY_REPORTED = "ALREADY_REPORTED",
    IM_USED = "IM_USED",
    MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
    MOVED_PERMANENTLY = "MOVED_PERMANENTLY",
    FOUND = "FOUND",
    /**
     * @deprecated
     */
    MOVED_TEMPORARILY = "MOVED_TEMPORARILY",
    SEE_OTHER = "SEE_OTHER",
    NOT_MODIFIED = "NOT_MODIFIED",
    /**
     * @deprecated
     */
    USE_PROXY = "USE_PROXY",
    TEMPORARY_REDIRECT = "TEMPORARY_REDIRECT",
    PERMANENT_REDIRECT = "PERMANENT_REDIRECT",
    BAD_REQUEST = "BAD_REQUEST",
    UNAUTHORIZED = "UNAUTHORIZED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    FORBIDDEN = "FORBIDDEN",
    NOT_FOUND = "NOT_FOUND",
    METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
    NOT_ACCEPTABLE = "NOT_ACCEPTABLE",
    PROXY_AUTHENTICATION_REQUIRED = "PROXY_AUTHENTICATION_REQUIRED",
    REQUEST_TIMEOUT = "REQUEST_TIMEOUT",
    CONFLICT = "CONFLICT",
    GONE = "GONE",
    LENGTH_REQUIRED = "LENGTH_REQUIRED",
    PRECONDITION_FAILED = "PRECONDITION_FAILED",
    PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
    /**
     * @deprecated
     */
    REQUEST_ENTITY_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE",
    URI_TOO_LONG = "URI_TOO_LONG",
    /**
     * @deprecated
     */
    REQUEST_URI_TOO_LONG = "REQUEST_URI_TOO_LONG",
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
    REQUESTED_RANGE_NOT_SATISFIABLE = "REQUESTED_RANGE_NOT_SATISFIABLE",
    EXPECTATION_FAILED = "EXPECTATION_FAILED",
    I_AM_A_TEAPOT = "I_AM_A_TEAPOT",
    /**
     * @deprecated
     */
    INSUFFICIENT_SPACE_ON_RESOURCE = "INSUFFICIENT_SPACE_ON_RESOURCE",
    /**
     * @deprecated
     */
    METHOD_FAILURE = "METHOD_FAILURE",
    /**
     * @deprecated
     */
    DESTINATION_LOCKED = "DESTINATION_LOCKED",
    UNPROCESSABLE_ENTITY = "UNPROCESSABLE_ENTITY",
    LOCKED = "LOCKED",
    FAILED_DEPENDENCY = "FAILED_DEPENDENCY",
    TOO_EARLY = "TOO_EARLY",
    UPGRADE_REQUIRED = "UPGRADE_REQUIRED",
    PRECONDITION_REQUIRED = "PRECONDITION_REQUIRED",
    TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
    REQUEST_HEADER_FIELDS_TOO_LARGE = "REQUEST_HEADER_FIELDS_TOO_LARGE",
    UNAVAILABLE_FOR_LEGAL_REASONS = "UNAVAILABLE_FOR_LEGAL_REASONS",
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
    NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
    BAD_GATEWAY = "BAD_GATEWAY",
    SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
    GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
    HTTP_VERSION_NOT_SUPPORTED = "HTTP_VERSION_NOT_SUPPORTED",
    VARIANT_ALSO_NEGOTIATES = "VARIANT_ALSO_NEGOTIATES",
    INSUFFICIENT_STORAGE = "INSUFFICIENT_STORAGE",
    LOOP_DETECTED = "LOOP_DETECTED",
    BANDWIDTH_LIMIT_EXCEEDED = "BANDWIDTH_LIMIT_EXCEEDED",
    NOT_EXTENDED = "NOT_EXTENDED",
    NETWORK_AUTHENTICATION_REQUIRED = "NETWORK_AUTHENTICATION_REQUIRED",
}

export const enum Operator {
    EQUAL = "EQUAL",
    NOT_EQUAL = "NOT_EQUAL",
    LIKE = "LIKE",
    NOT_LIKE = "NOT_LIKE",
    STARTS_WITH = "STARTS_WITH",
    END_WITH = "END_WITH",
    IN = "IN",
    NOT_IN = "NOT_IN",
    GREATER_THAN = "GREATER_THAN",
    GREATER_OR_EQUAL_TO = "GREATER_OR_EQUAL_TO",
    LESS_THAN = "LESS_THAN",
    LESS_OR_EQUAL_TO = "LESS_OR_EQUAL_TO",
    BETWEEN = "BETWEEN",
}

export const enum FieldType {
    BOOLEAN = "BOOLEAN",
    CHAR = "CHAR",
    DATE = "DATE",
    INSTANT = "INSTANT",
    DOUBLE = "DOUBLE",
    INTEGER = "INTEGER",
    LONG = "LONG",
    STRING = "STRING",
    UUID = "UUID",
    ENUM_STRING = "ENUM_STRING",
}

export const enum SortDirection {
    ASC = "ASC",
    DESC = "DESC",
}

export const enum Direction {
    ASC = "ASC",
    DESC = "DESC",
}

export const enum NullHandling {
    NATIVE = "NATIVE",
    NULLS_FIRST = "NULLS_FIRST",
    NULLS_LAST = "NULLS_LAST",
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'AxiosClientExtension' extension

import axios from "axios";
import * as Axios from "axios";

declare module "axios" {
    export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
        data: R;
    }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {

    constructor(private axios: Axios.AxiosInstance) {
    }

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Axios.AxiosRequestConfig; }): RestResponse<R> {
        function assign(target: any, source?: any) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }

        const config: Axios.AxiosRequestConfig = {};
        config.method = requestConfig.method as typeof config.method;  // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;

        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                (axiosResponse as any).originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
